/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, TimeService, UNPLACEHOLDER } from '@dm/core';
import { type SelectOption } from '@dm/core/types';
import { notSupportTimeZone, timeZones } from 'app/config';

export enum ModifyModeE {
    Manual = '0',
    SyncClient = '1',
    Ntp = '2'
}

export enum CommandNameE {
    ModifyTime = 'ModifyTime',
    ModifyTimeZone = 'ModifyTimeZone',
    SyncClientTime = 'SyncClientTime',
    SyncClientTimeZone = 'SyncClientTimeZone',
    CloseNtpConfig = 'CloseNtpConfig',
    ModifyNtpConfig = 'ModifyNtpConfig'
}

@Injectable({ providedIn: 'root' })
export class DeviceTimeStrService {
    get = this.i18nService.get;

    i18n = {
        title: this.get('common.systemTime_title'),

        currentDeviceTimeLab: this.get('settings.systemTime_task_currentDeviTim_lab'),
        modifyModeLab: this.get('settings.systemTime_task_modifyMode_lab'),
        afterModifyTimeLab: this.get('settings.systemTime_task_modifyDeviTim_lab'),
        timeLab: this.get('common.time_label'),
        timeZoneLab: this.get('settings.systemTime_task_setTime_para_timeZone_label'),
        ntpSyncLab: this.get('settings.systemTime_term_syncNTPtime_btn'),
        ntpIpLab: this.get('settings.systemTime_term_NTPServerIpAddress_label'),
        ntpAuthLab: this.get('settings.systemTime_term_ntpAuthentication_label'),
        statusLab: this.get('settings.systemTime_task_NTPStatues_status_lab'),
        offsetTip: this.get('settings.systemTime_task_NTPStatues_offset_tip'),
        offsetLab: this.get('settings.systemTime_task_NTPStatues_offset_lab'),
        currentIpLab: this.get('settings.systemTime_task_ConnectNTPServerIp_label'),
        colonLab: this.get('common.colon_label'),
        dstLab: this.get('common.dst_label'),
        caLab: this.get('settings.certificateManage_CACertificate_col'),
        clientTimeZoneLab: this.get('settings.systemTime_task_clientZone_lab'),
        syncClientTimeTip: this.get('settings.systemTime_term_synClientTime_tip'),
        enabledLab: this.get('common.service_enable_value'),
        disabledLab: this.get('common.service_disable_value'),
        ntpLab: this.get('settings.systemTime_task_syncNTPtime_lab'),
        ntpSyncTitle: this.get('settings.systemTime_term_syncNTPtime_tittle'),

        enableText: this.get('common.enable_label'),

        selectTimeZoneTip: this.get('common.select_lab1'),
        ntpTip: this.get('settings.systemTime_task_setTime_option_syncNTPtime_description_label'),
        ntpAuthTip: this.get('settings.systemTime_term_ntpAuthentication_tip'),
        ipTip: this.get('common.IPv4orIPv6orDomainName_label'),

        syncClientTimeBtn: this.get('settings.systemTime_task_synClientTim_title'),
        saveBtn: this.get('common.save_button'),
        cancelBtn: this.get('common.cancel_button'),
        testBtn: this.get('common.test'),
        configureBtn: this.get('common.configure_button'),
        okBtn: this.get('common.confirm_button'),

        modifyTimeResult: this.get('rest.modifySystemUtcTime_msg'),
        modifyTimeTitle: this.get('settings.systemTime_task_modifyDeviTim_title'),
        modifyTimeMsg: this.get('settings.systemTime_task_setTime_confirmation_message'),
        modifyTimeMsgForOem: this.get('settings.systemSetting_initialization_task2_setTime_confirmation_oem_message'),
        modifyTimeZoneResult: this.get('rest.modifyTimeZone_msg'),
        modifyTimeZoneTitle: this.get('settings.systemTime_task_modifyDeviZone_title'),
        modifyTimeZoneMsg: this.get('settings.systemTime_task_modifyZone_info_msg'),
        modifyTimeZoneMsgForOem: this.get('settings.system_initConfig_task_modifyZone_info_oem_msg'),
        modifyTimeAndTimeZoneTitle: this.get('settings.systemTime_task_modifyDeviTimZone_title'),
        modifyTimeAndTimeZoneMsg: this.get('settings.systemTime_task_modifyZoneAndTime_info_msg'),
        modifyTimeAndTimeZoneMsgForOem: this.get('settings.systemTime_task_modifyZoneAndTime_info_oem_msg'),
        syncClientClientTitle: this.get('settings.systemTime_task_synClientTim_title'),
        syncClientClientMsg: this.get('settings.systemTime_term_setTime_info_clientTimeSyn_msg'),
        syncClientClientMsgForOem: this.get('settings.systemTime_term_setTime_info_clientTimeSyn_oem_msg'),
        modifyNtpResult: this.get('settings.systemTime_task_modifyNTPConfig_title'),
        modifyNtpTitle: this.get('settings.systemTime_task_modifyNTPConfig_title'),
        modifyNtpMsg: this.get('settings.systemTime_task_setTime_info_excuteTimeSyn_NTP_message'),
        modifyNtpMsgForOem: this.get('settings.systemSetting_initialization_task2_setTime_info_excuteTimeSyn_oem_message'),
        closeNtpResult: this.get('rest.closeNTPClientConfig_msg'),
        checkSuccessResult: this.i18nService.get('settings.systemTime_task_testNTPAddress_success_msg'),

        modifyModeRequiredErr: this.get('settings.systemTime_task_selectOneMode_err_lab'),
        ntpCurrentIpTip: this.get('settings.systemTime_term_NTPServerIpAddress_tip'),
        ntpIpNullErr: this.get('common.null_validation', [
            this.get('settings.systemTime_term_NTPServerIpAddress_label'),
        ]),
        ntpIpFormatErr: this.get('settings.systemTime_task_addDomainServer_serverIP_msg'),
        ntpIpRepeatErr: this.get('settings.systemTime_task_serverIPAddress_info_sameIp_label'),
        ntpRequiredErr: this.get('settings.systemTime_task_syncNTPtime_err_lab'),
    };

    modifyOpts: SelectOption[] = [
        {
            label: this.get('settings.systemTime_term_synClientTime_btn'),
            value: ModifyModeE.SyncClient,
            data: this.get('settings.systemTime_term_synClientTime_tip'),
        },
        {
            label: this.get('settings.systemTime_task_modifyMode_manual_value'),
            value: ModifyModeE.Manual,
            data: this.get('settings.systemTime_task_modifyMode_manual_desc'),
        },
        {
            label: this.get('settings.systemTime_term_syncNTPtime_btn'),
            value: ModifyModeE.Ntp,
            data: this.get('settings.systemTime_task_setTime_option_syncNTPtime_description_label'),
        },
    ];

    ntpStatusMap = {
        0: this.get('common.EnumDefine_STATUS_E_NORMAL'),
        1: this.get('common.EnumDefine_STATUS_E_ABNORMAL'),
        2: UNPLACEHOLDER,
    };

    timeZones: SelectOption[] = timeZones[this.i18nService.language].filter(({ value }) => {
        const timeZoneConfig = this.timeService.getTimeZoneConfig();
        // 如果当前时区为要屏蔽的时区则不屏蔽：兼容快速升级场景; 不支持时区列表屏蔽
        const result = notSupportTimeZone.includes(value) && timeZoneConfig && timeZoneConfig.timeZoneName !== value;
        return !result;
    });

    constructor(
        private i18nService: I18nService,
        private timeService: TimeService,
    ) {}
}
